export default "__VITE_ASSET__DJ5jyH5Y__"